Cm.header = {
    init: function() {
        $(document).on('click', Cm.o('menu.toggleEl'), function() {
            Cm.header.show();
        });

        $(document).on('click', Cm.o('menu.overlayClass'), function() {
            Cm.header.hide();
        });

        $(window).on('resize', this.screen);

        Cm.header.headerDropDownToggle();
    },
    show: function() {
        $(Cm.o('menu.targetEl')).addClass(Cm.o('menu.activeClass'));
        $(Cm.o('menu.overlayClass')).removeClass('d-none');
    },
    hide: function(timer) {
        $(Cm.o('menu.targetEl')).removeClass(Cm.o('menu.activeClass'));
        setTimeout(function() {
            $(Cm.o('menu.overlayClass')).addClass('d-none');
        }, timer||200);
    },
    screen: function() {
        var w = document.documentElement.clientWidth;        
        if(w > Cm.o('menu.width.expandMin')) Cm.header.hide(-1);
    },
    headerDropDownToggle: function() {
        if (!$('.header__dropdown-name').length) {
            return;
        }
        $(document).on('click', '.header__dropdown-name', function() {
            $('.header__dropdown-list').slideToggle();
        });
    }
}